<template>
  <!-- Mirrors the cookie banner on xeo.vision -->
  <section
    v-if="bannerVisible"
    ref="banner"
    aria-labelledby="consent-title"
    aria-describedby="consent-text"
    class="fixed inset-x-3 bottom-[calc(12px_+_env(safe-area-inset-bottom,0px))] z-50 mx-auto grid max-h-[calc(100dvh_-_24px)] max-w-[54rem] items-center gap-x-7 gap-y-4 overflow-auto rounded-xl border border-[#bec3c9] bg-white p-[18px] text-[#1c1e21] shadow-[0_10px_30px_#0607294d] sm:grid-cols-[1fr_auto] sm:px-6 sm:py-5 dark:border-[#4a4d50] dark:bg-[#1b1b1d] dark:text-[#e3e3e3] print:hidden"
    :class="{ 'pr-14 sm:pr-14': choice }"
    @keydown.esc="choice && (bannerVisible = false)"
  >
    <div>
      <p id="consent-title" class="font-bold leading-snug text-[#060729] dark:text-[#f2f3f7]">
        Help us improve xeoVision
      </p>
      <p
        id="consent-text"
        class="mt-1 text-[0.9rem] leading-relaxed text-[#525860] dark:text-[#b0b3b8]"
      >
        We use a few analytics cookies to make the site better. No ads, no tracking across websites.
        <a
          href="https://xeo.vision/privacy-policy/"
          target="_blank"
          rel="noopener"
          class="whitespace-nowrap text-[#6e12ff] underline underline-offset-2 dark:text-[#a97dff]"
        >
          Privacy policy
        </a>
      </p>
      <p v-if="choice" role="status" class="mt-1.5 text-[0.85rem]">
        Current choice: analytics cookies {{ choice === 'granted' ? 'accepted' : 'rejected' }}.
      </p>
    </div>

    <div class="flex gap-2.5">
      <button
        v-for="option in options"
        :key="option.value"
        type="button"
        class="min-h-11 min-w-[108px] flex-1 rounded-[10px] bg-[#060729] px-5 text-[0.92rem] font-semibold text-white transition-opacity hover:opacity-85 sm:flex-none dark:bg-[#f2f3f7] dark:text-[#1b1b1d]"
        @click="set(option.value)"
      >
        {{ option.label }}
      </button>
    </div>

    <button
      v-if="choice"
      type="button"
      aria-label="Keep my current choice"
      class="absolute right-2 top-2 inline-flex size-8 items-center justify-center rounded-full text-[#8d949e] hover:bg-[#ebedf0] hover:text-[#1c1e21] dark:text-[#8f959c] dark:hover:bg-[#303234] dark:hover:text-[#e3e3e3]"
      @click="bannerVisible = false"
    >
      <X :size="15" :stroke-width="2.2" />
    </button>
  </section>
</template>

<script setup lang="ts">
import { X } from 'lucide-vue-next';

const { choice, bannerVisible, set } = useConsent();

const options = [
  { value: 'granted', label: 'Accept' },
  { value: 'denied', label: 'Reject' },
] as const;

// Reopened from "Cookie preferences": move focus into the banner and give it back on close.
const banner = ref<HTMLElement>();
let returnFocus: HTMLElement | null = null;
watch(bannerVisible, async (visible) => {
  if (visible) {
    returnFocus = document.activeElement as HTMLElement | null;
    await nextTick();
    banner.value?.querySelector('button')?.focus();
  } else {
    returnFocus?.focus();
    returnFocus = null;
  }
});
</script>
